import axiosRequest from '@/utils/axios'

export const voiceSearch = (data,configData) =>
    axiosRequest.post(`/gateway-apis/tts/v1/voiceSearch/link`,data,configData)
export default {
    voiceSearch,
}